// src/environments/environment.ts
import { Environment } from './environment.model';
export const environment: Environment = {
  production: false,
  stage: 'PROD',
  region: 'NAFTA',
  apiBaseUrls: {
    NAFTA: 'https://7x9woiwjc7.execute-api.us-east-1.amazonaws.com/fcl/v1'
  },
  cognitoConfigs: {
    NAFTA: {
      aws_project_region: 'us-east-1',
      aws_cognito_region: 'us-east-1',
      aws_user_pools_id: 'us-east-1_6hA2CSFNH',
      aws_user_pools_web_client_id: '5stc1ii8eil10h1f55p0se5pfs',
    }
  },
  zuoraEntity: ['NAFTA', 'MAS_NAFTA', 'LATAM']
};